import { Injectable } from '@angular/core';
import { Broker } from '@c4/core';

@Injectable()
export class LogService {

  constructor(private broker: Broker) {}

  public getLogs = (ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {
      let request: any = {
        method: 'GET',
        path: '/api/v1/sysman/log' + (ip ? "?ip=" + ip : "")
      };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  public getBrokerLogLevel = (ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {
        let request: any = {
          method: 'GET',
          path: '/api/v1/logger/level' + (ip ? "?ip=" + ip : "")
      };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  //  change broker's log level
  //  where :level is "verbose", "info", "warning", "error"
  public setBrokerLogLevel = (level: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {
        let request: any = {
          method: 'PUT',
          path: '/api/v1/logger/level',
          data: {'level':level}
        };
        this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  // change log level where log is not broker
  public setLogLevel = (logname: string, level: string, ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

        let sendPost: any = {};
        sendPost["logger"] = logname;
        sendPost["level"] = level;
        if (ip)
            sendPost["ip"] = ip;

        let request: any = {
            method: 'POST',
            path: '/api/v1/sysman/log',
            data: sendPost
        };

        this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  // supports getting remote log files ?ip=xx.xx.xx.xx
  public getLogFile = (logname: string, ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

      let request: any = {
        method: 'GET',
        path: '/api/v1/logs/' + logname + (ip ? "?ip=" + ip : "")
      };
      this.broker.callNonJSON(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }
  
  // subscription does not support remote log files
  public tailLogFile = (logname: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

      let request: any = {
        method: 'GET',
        path: '/api/v1/logs/' + logname
      };

      this.broker.subscribe(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }  

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/log.service.ts